var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 300,
    viewBox: "0 0 512 512",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_188644184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_188642744"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m481 396h-310c-17 0-31-14-31-32v-151c0-17 14-32 31-32h310c17 0 31 15 31 32v151c0 18-14 32-31 32zm-310-201c-9 0-17 8-17 18v151c0 10 8 18 17 18h310c9 0 17-8 17-18v-151c0-10-8-18-17-18z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188643728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 345h-160c-32 0-57-25-57-56 0-32 25-57 57-57h160c4 0 7 3 7 7v99c0 4-3 7-7 7zm-160-99c-24 0-43 19-43 43 0 23 19 42 43 42h153v-85z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188643752"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147 369h-47c-4 0-7-3-7-7v-147c0-4 3-7 7-7h47c4 0 7 3 7 7v147c0 4-3 7-7 7zm-40-14h33v-133h-33z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188641208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 400c-1 0-3 0-4-1-2-1-3-3-3-6v-209c0-3 1-5 3-6s4-2 6-1l93 31c3 1 5 4 5 7v147c0 3-2 6-5 7l-93 31s-1 0-2 0zm7-207v191l79-27v-137z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188643008"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246 195c-50 0-90-40-90-90s40-90 90-90 91 40 91 90-41 90-91 90zm0-166c-42 0-76 34-76 76s34 76 76 76 77-34 77-76-35-76-77-76z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188643056"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191 112c-4 0-7-3-7-7 0-34 28-62 62-62 4 0 7 3 7 7 0 3-3 7-7 7-27 0-48 21-48 48 0 4-3 7-7 7z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188641856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m413 195c-50 0-90-40-90-90s40-90 90-90 90 40 90 90-40 90-90 90zm0-166c-42 0-76 34-76 76s34 76 76 76 76-34 76-76-34-76-76-76z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188643968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357 112c-3 0-7-3-7-7 0-34 28-62 63-62 4 0 7 3 7 7 0 3-3 7-7 7-27 0-49 21-49 48 0 4-3 7-7 7z",
    fill: "#c72538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_188644304"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m385 497c-3 0-5-1-6-3l-53-91-53 91c-2 3-6 4-9 2-4-1-5-6-3-9l59-102c1-2 4-3 6-3 3 0 5 1 6 3l59 102c2 3 1 8-3 9-1 1-2 1-3 1z",
    fill: "#c72538"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.777d46300ac195643f1029ddada4d8ec.svg";
export { ForwardRef as ReactComponent };